<script>

    import { createEventDispatcher } from 'svelte'
    import { replace } from 'svelte-spa-router'
    import { toast } from 'bulma-toast'

    import UsersService from '../$services/users.service.js'

    import InputText from '../$components/input.text.svelte'
    import Button from '../$components/button.svelte'

    const dispatch = createEventDispatcher()

    let data = {}
    let loading = false

    const authorizedRoles = ['admin', 'adviser', 'almacen']

    async function userLogin() {

        loading = true
        const resp = await UsersService.userLogin(data)
        loading = false

        if (!resp.success)
            return toast({ message: resp.error.message, type: 'is-danger' })

        const user = resp.data.user

        if (authorizedRoles.indexOf(user.role) === -1)
            return toast({ message: 'Usuario no autorizado', type: 'is-danger' })

        replace('#/shipments')
    }

</script>

<form class="login-form" on:submit|preventDefault={userLogin} novalidate>
    <InputText
        label="Correo electrónico"
        bind:value={data.email}
        type="email"
        name="username"
        inputmode="email"
        autocomplete="username"
        placeholder="nombre@ejemplo.com"
        required
    />

    <InputText
        label="Contraseña"
        bind:value={data.password}
        type="password"
        name="password"
        autocomplete="current-password"
        placeholder="Tu contraseña"
        required
    />

    <div class="login-form__actions">
        <Button
            type="submit"
            color="primary"
            icon="sign-in-alt"
            text="Ingresar"
            fullwidth
            {loading}
        />
    </div>

    <div class="login-form__footer">
        <button type="button" class="login-form__link" on:click={() => dispatch('recover', data.email)}>
            ¿Olvidaste tu contraseña?
        </button>
    </div>
</form>

<style>
    .login-form :global(.field:last-of-type) {
        margin-bottom: 0;
    }

    .login-form__actions {
        margin-top: 0.875rem;
        padding-top: 0;
    }

    .login-form__footer {
        margin-top: 1rem;
        text-align: center;
    }

    .login-form__link {
        padding: 0;
        border: 0;
        background: none;
        cursor: pointer;
        font-size: 0.8125rem;
        font-weight: 500;
        color: var(--til-muted);
        text-decoration: underline;
        text-underline-offset: 2px;
    }

    .login-form__link:hover {
        color: var(--til-ink);
    }
</style>
